import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccountTreeModel } from './account-tree.model';

@Component({
  selector: 'account-tree',
  templateUrl: './account-tree.component.html',
  styleUrls: ['./account-tree.component.scss'],
})
export class AccountTreeComponent {
  _accounts: AccountTreeModel[] = [];
  @Input()
  get accounts() {
    return this._accounts;
  }
  set accounts(val: AccountTreeModel[]) {
    let original = this._accounts;
    this._accounts = val;
    this._accounts.forEach((it, index) => {
      it.styleClass = `${it.styleClass || ''} card`;
      it.type = 'account';
      it.children?.forEach((child) => (child.type = 'contact'));
      if (original.length == this._accounts.length) {
        it.expanded = original[index].expanded;
      }
    });
  }

  _selected: AccountTreeModel[] = [];
  @Input()
  get selected() {
    return this._selected;
  }
  set selected(val: AccountTreeModel[]) {
    this._selected = val;
  }

  @Output()
  selectedChange: EventEmitter<AccountTreeModel[]> = new EventEmitter<
    AccountTreeModel[]
  >();

  _style: any = { width: '100%', padding: 0 };
  @Input()
  set style(val: any) {
    this._style = { width: '100%', padding: 0, ...val };
  }
  get style() {
    return this._style;
  }

  @Input()
  filter: boolean = true;

  @Input()
  filterPlaceholder: string;

  @Input()
  scrollHeight: string = 'calc(100% - 35px)';

  @Input()
  filterBy: string;

  _styleClass: string = 'account-tree';
  @Input()
  set styleClass(val: string) {
    this._styleClass = `${val || ''} account-tree`;
  }
  get styleClass(): string {
    return this._styleClass;
  }

  @Input()
  trackBy: Function = (index: number, item: AccountTreeModel) => item.key;

  @Input()
  emptyMessage: string = '';

  getContactCounts(account: AccountTreeModel) {
    return `(${account?.children?.length || 0} contacts)`;
  }

  onSelectionChange(selectedNodes: AccountTreeModel[]) {
    this.selectedChange.emit(selectedNodes);
  }

  constructor() {}
}
